/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" d="M6.554 2.313a4.223 4.223 0 014.241 4.241 4.224 4.224 0 01-4.24 4.241 4.224 4.224 0 01-4.242-4.24 4.224 4.224 0 014.241-4.242m0-2.313C2.948 0 0 2.948 0 6.554c0 3.606 2.948 6.554 6.554 6.554a6.503 6.503 0 003.741-1.18l3.536 3.542a1.16 1.16 0 001.639-1.639l-3.542-3.536a6.503 6.503 0 001.18-3.74C13.108 2.947 10.16 0 6.554 0"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/search.js